import React from "react";
import classNames from "classnames";
import Preloader from "../Preloader";
import { useImage } from "./useImage";

const Image = (props) => {
  const { alt = "img", src, retina, className, auth = true, style } = props;
  const authenticatedImg = useImage({ src: auth ? src : null, retina: auth ? retina : null });
  const img = auth ? authenticatedImg : { src };

  const retinaSrcSet = img.retina ? `, ${img.retina} 2x` : "";
  const srcSet = `${img.src} 1x${retinaSrcSet}`;

  return (
    <div className={classNames("image-container flex flex-justify-center flex-items-center", className)} style={style}>
      {img.src ? (
        <img alt={alt} src={img.src} srcSet={srcSet} />
      ) : (
        <span className="inline-flex">
          <Preloader />
        </span>
      )}
    </div>
  );
};

export default Image;
